type PaginationItemValue = number | 'start-ellipsis' | 'end-ellipsis';

const MAX_VISIBLE_ITEMS = 7;
// Pages shown at each end of a collapsed range, counting the current page's neighbours.
const EDGE_RANGE = 5;
const NEAR_EDGE_OFFSET = 4;
const NEIGHBOUR_COUNT = 1;

/**
 * Page numbers and gaps to display. Long ranges keep a constant number of slots
 * (first, last, the current page and its neighbours) so the control never grows.
 */
const getPaginationItems = (
  currentPage: number,
  totalPages: number,
): PaginationItemValue[] => {
  const range = (from: number, to: number): number[] =>
    Array.from({ length: to - from + 1 }, (_, index) => from + index);

  if (totalPages <= MAX_VISIBLE_ITEMS) {
    return range(1, totalPages);
  }

  if (currentPage <= NEAR_EDGE_OFFSET) {
    return [...range(1, EDGE_RANGE), 'end-ellipsis', totalPages];
  }

  if (currentPage >= totalPages - NEAR_EDGE_OFFSET + 1) {
    return [1, 'start-ellipsis', ...range(totalPages - EDGE_RANGE + 1, totalPages)];
  }

  return [
    1,
    'start-ellipsis',
    ...range(currentPage - NEIGHBOUR_COUNT, currentPage + NEIGHBOUR_COUNT),
    'end-ellipsis',
    totalPages,
  ];
};

export { getPaginationItems };
